import gsap from 'gsap'

import {
  fadeRevealAnimation,
  getScrollTriggerOptions,
  linesRevealAnimation,
  mediaFadeRevealAnimation,
  type SharedAnimation
} from '@/components/sections/animations/shared'

import { Animation } from '@/types'

export const imageTextRevealAnimation = ({
  node,
  context,
  reverse,
  delay = 0
}: Animation) => {
  const selector = context?.selector || gsap.utils.selector(node)

  const media = selector('[data-motion-media]')[0]
  const title = selector('[data-motion-title]')[0]
  const text = selector('[data-motion-text]')[0]
  const ctas = selector('[data-motion-ctas]')[0]

  // Media has its own scroll trigger — animates when it enters the viewport
  let mediaTimeline: gsap.core.Timeline
  let mediaAnimation: SharedAnimation
  if (media) {
    mediaAnimation = mediaFadeRevealAnimation(media)
    mediaTimeline = gsap.timeline({
      ...getScrollTriggerOptions(media, reverse),
    })
    mediaTimeline.add(mediaAnimation.timeline, 0)
  }

  // Text content is triggered by the section entering the viewport
  const textTimeline = gsap.timeline({
    ...getScrollTriggerOptions(node, reverse),
    delay
  })

  let titleAnimation: SharedAnimation
  if (title) {
    titleAnimation = linesRevealAnimation(title, reverse)
    textTimeline.add(titleAnimation.timeline, 0)
  }

  let textAnimation: SharedAnimation
  if (text) {
    textAnimation = linesRevealAnimation(text, reverse)
    textTimeline.add(textAnimation.timeline, 0.15)
  }

  let ctasAnimation: SharedAnimation
  if (ctas) {
    ctasAnimation = fadeRevealAnimation(ctas)
    textTimeline.add(ctasAnimation.timeline, 0.3)
  }

  return () => {
    mediaTimeline?.scrollTrigger?.kill()
    mediaTimeline?.kill()
    textTimeline.scrollTrigger?.kill()
    textTimeline.kill()

    mediaAnimation?.revert()
    titleAnimation?.revert()
    textAnimation?.revert()
    ctasAnimation?.revert()
  }
}
